import React, { FC, ReactNode } from 'react'
import ReactDOM from 'react-dom';
import style from '../../../styles/components/modal.module.css';
import { ModalSizeType } from '../../../types/modal.type';
import { useGetLangDirectionApp } from '../../../stores/app.store';

type ModalOverlayProps = {
  children: ReactNode,
  modalSize: ModalSizeType
}


type ModalProps = {
  children: ReactNode,
  modalSize: ModalSizeType
}

const Backdrop = () => {
  return <div className={style.backdrop}></div>
}

const ModalOverlay: FC<ModalOverlayProps> = ({ children, modalSize }) => {

  const langDirection = useGetLangDirectionApp();
  let classes = style.modal;

  switch (modalSize) {
    case 'S':
      classes += ' ' + style.modalSizeS;
      break;
    case 'M':
      classes += ' ' + style.modalSizeM;
      break;
    case 'L':
      classes += ' ' + style.modalSizeL;
      break;
    case 'XL':
      classes += ' ' + style.modalSizeXL;
      break;
    default:
      classes += ' ' + style.modalSizeM;
      break;
  }

  return (
    <div className={classes} dir={langDirection}>
      {children}
    </div>
  );
}

const portalElement = document.getElementById('overlays');

const Modal: FC<ModalProps> = ({ children, modalSize = 'M' }) => {
  return (
    <React.Fragment>
      {ReactDOM.createPortal(<Backdrop />, portalElement)}
      {ReactDOM.createPortal(<ModalOverlay modalSize={modalSize}>{children}</ModalOverlay>, portalElement)}
    </React.Fragment>
  );
}


export default Modal;